module.exports = __webpack_public_path__ + "e6ef357e.png";